import React from "react";

const NonAuth = (props) => {

  return <>{props.children}</>;
};


export { NonAuth };